import {MenuOutlined} from '@ant-design/icons';
import React from 'react';
import {Dropdown, Layout, Menu} from 'antd';
import {inject} from 'mobx-react';
import useMedia from 'use-media';

const {Header} = Layout;

const MainHeader = ({store}) => {
  const isMobile = useMedia({
    maxWidth: 768
  });

  const handleMenuClick = ({key}) => {
    switch (key) {
      case 'logout':
        store.auth.logout();
        break;
    }
  };

  const userMenu = (
    <Menu onClick={handleMenuClick}>
      {isMobile && <Menu.Item key="user">{store.user.email}</Menu.Item>}
      {isMobile && <Menu.Divider />}
      <Menu.Item key="logout">Log out</Menu.Item>
    </Menu>
  );

  return (
    <Header className="main-header">
      <h2 className="main-logo">MONEI Wallet</h2>
      <Dropdown overlay={userMenu}>
        {isMobile ? (
          <div className="main-menu-mobile">
            <MenuOutlined style={{fontSize: 24}} />
          </div>
        ) : (
          <Menu theme="dark" mode="horizontal" selectedKeys={[]}>
            <Menu.Item>{store.user.email}</Menu.Item>
          </Menu>
        )}
      </Dropdown>
    </Header>
  );
};

export default inject('store')(MainHeader);
